import React from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

export default function MessageAdminModal({
  show,
  onHide,
  adminMsgText,
  setAdminMsgText,
  handleSendAdminMsg,
  adminMsgSendError,
  adminMsgSendSuccess
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Message Admin</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Type your message to admin</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={adminMsgText}
            onChange={e => setAdminMsgText(e.target.value)}
          />
        </Form.Group>
        {adminMsgSendError && <Alert variant="danger" className="mt-2">{adminMsgSendError}</Alert>}
        {adminMsgSendSuccess && <Alert variant="success" className="mt-2">{adminMsgSendSuccess}</Alert>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSendAdminMsg}
          disabled={!adminMsgText.trim()}
        >
          Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
